/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { Box, Grid, Typography, FormControlLabel, Switch } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import './ActivedocCard.css';
import { fonts, themes } from '../themes/themes';

const GreenSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: themes.green,
    '&:hover': {
      backgroundColor: alpha(themes.green, theme.palette.action.hoverOpacity),
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: 'green',
  },
}));

interface ICustomEditCardProps {
  card_title?: string;
  card_subtitle?: string;
  card_height?: string;
  trans?: any;
  checked?: any;
}

const ExpiredDocCard: React.FC<
  React.PropsWithChildren<ICustomEditCardProps>
> = ({ children, card_title, card_height, card_subtitle, trans, checked }) => {
  const [check, setChecked] = useState(false);

  const handleChecked = (value: boolean) => {
    setChecked(value);
    checked(!value);
  };

  return (
    <Box
      style={{
        width: 'auto',
        padding: '1.75em',

        /* UI Properties */
        background: '#ffffff 0% 0% no-repeat padding-box',
        boxShadow: '0px 1px 2px #00000029',
        borderRadius: '15px',
        opacity: 1,

        maxHeight: card_height,
        height: 'auto',
      }}
    >
      <Grid container>
        <Grid
          item
          xs={12}
          style={{
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          <Grid
            item
            xs={6}
            style={{
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
            }}
          >
            <Typography
              style={{
                color: themes.red,
                fontSize: fonts.header,
                fontWeight: 'bold',
              }}
            >
              {card_title}
            </Typography>
            <Typography
              style={{
                color: themes.defaultIcon,
                fontSize: fonts.subtitle,
                fontFamily: fonts.fontFamily,
              }}
            >
              {card_subtitle}
            </Typography>
          </Grid>
          <Grid
            item
            xs={7}
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
            }}
          >
            <Typography
              style={{
                color: themes.blackDefault,
                fontSize: fonts.title,
                fontWeight: 'bold',
              }}
            >
              {trans('Mute Expired Notifications')}
            </Typography>
            <FormControlLabel
              control={
                <GreenSwitch
                  checked={check}
                  onChange={(e) => handleChecked(e.target.checked)}
                />
              }
              label={check ? trans('Yes') : trans('No')}
              style={{
                color: themes.green,
                fontSize: '0.85em',
              }}
            />
          </Grid>
        </Grid>
      </Grid>
      <Box className="scrollbar__class">{children}</Box>
    </Box>
  );
};

export default ExpiredDocCard;
